import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'

// 获取群基本信息和成员信息
export function webGetClusterAndMember(clusterId,callback){
	request({
			method: 'post',
			url: 'cluster/detail',
			data: {
				clusterId:clusterId
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 修改群信息
export function webSaveInfo(param,callback){
	request({
			method: 'post',
			url: 'cluster/save',
			data: param
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 修改群信息
export function webCreateCluster(param,callback){
	request({
			method: 'post',
			url: 'cluster/createCluster',
			data: param
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 删除群信息
export function webDeleteCluster(clusterId,callback){
	request({
			method: 'post',
			url: 'cluster/deleteCluster',
			data: {
				clusterId:clusterId
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(true)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 获取待同步的群列表
export function webGetSyncCluster(open_id,async_cluster_id,callback){
	request({
			method: 'post',
			url: 'cluster/getList',
			data: {
				openId:open_id,
				asyncClusterId:async_cluster_id
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据群id，获取群的成员列表
export function webGetClusterMember(cluster_id,callback){
	request({
			method: 'post',
			url: 'cluster/getClusterMember',
			data: {
				cluster_id:cluster_id,
				only_custom:1
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}